/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 *
 * ======================================================================== */

// window.$ = window.jQuery = require('jquery');

// Define Methods/Functions outside the router for reusability

import {
    Broadcaster,
    Scroller,
    MobileNav,
    Debounce,
    Collapser,
    ImagesLoaded,
    LazyLoad,
    Maps,
    FormFocus,
    ScrollDown,
    SharePost,
    CookieConsent,
    Accessible,
    Tabs
} from './modules'
import Cookies from 'js-cookie';
import Swiper from 'swiper/bundle'; // import Swiper with all modules (required for Pagination and Navigation)
import fancybox from '@fancyapps/fancybox/dist/jquery.fancybox.js';

const Router = {

    common: {

        init() {
            MobileNav.init('.js-navigation-toggle');
            Accessible.init('.menu-item');
            CookieConsent.init('.js-consent-box','.js-consent-btn');
            ImagesLoaded.init('.js-loaded');
            LazyLoad.init('.js-lazy-element');
			Collapser.init('.js-collapser-toggle');
            Tabs.init();

			const slider = new Swiper ('.js-slider', {
				pagination: {
					el: '.js-slider-pagination',
				},
				navigation: {
					nextEl: '.js-slider-next',
					prevEl: '.js-slider-prev',
				},
            });

            const testimonialSlider = new Swiper ('.js-testimonial-slider', {
                // initialSlide: 1,
                slidesPerView: "auto",
                centeredSlides: false,
                loop: true,
                speed: 400,
                autoplay: {
                    delay: 4000
                },
				pagination: {
					el: '.js-slider-pagination',
				},
				navigation: {
					nextEl: '.js-slider-next',
					prevEl: '.js-slider-prev',
				},
            });

            const logoSlider = new Swiper ('.js-logo-slider', {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 20,
                // centeredSlides: false,
                centeredSlides: true,
                speed: 2000,
                freeMode: true,
                autoplay: {
                    delay: 1,
                    disableOnInteraction: false,
                },
                loop: true,
                allowTouchMove: false,
				pagination: false,
                breakpoints: {
                    500: {
                        slidesPerView: 3,
                        slidesPerGroup: 1,
                        spaceBetween: 30,
                        speed: 3000
                    },
                    720: {
                        slidesPerView: 4,
                        slidesPerGroup: 1,
                        spaceBetween: 30,
                        speed: 3000
                    },
                    840: {
                        slidesPerView: 6,
                        slidesPerGroup: 1,
                        spaceBetween: 30,
                        speed: 4000
                    },
                    1200: {
                        slidesPerView: 9,
                        slidesPerGroup: 1,
                        spaceBetween: 50,
                        speed: 4000
                    },
                    2000: {
                        slidesPerView: 14,
                        slidesPerGroup: 1,
                        spaceBetween: 50,
                        speed: 6000
                    }
                }
            });

            // Enable video popups for video tab/enter
            if ( $('.video-popup-js') ) {
                $('.video-popup-js').keydown(function(event){ 
                    var keyCode = (event.keyCode ? event.keyCode : event.which);   
                    if (keyCode == 13) {
                        $(this).trigger('click');
                    }
                });
            }

            // Enable video popups for video tab/enter
            if ( $('.form-popup-js') ) {
                $('.form-popup-js a').keydown(function(event){ 
                    var keyCode = (event.keyCode ? event.keyCode : event.which);   
                    if (keyCode == 13) {
                        $(this).trigger('click');
                    }
                });
            }

            // Add scrolled class to header
            function isScrolled() {
                if(window.pageYOffset > 80) {
                    $('header#site-header').addClass('is-scrolled-js');
                } else {
                    $('header#site-header').removeClass('is-scrolled-js');
                }
            }
            isScrolled();

            document.addEventListener('scroll', function (event) {
                isScrolled();
            }, {passive: true});

            // Blog Categories Filter
            $( '#categories' ).on('change', function() {
                if ( $(this).val() != 'All' ) {
                    window.location.href = $(this).val();
                }
            });

            // Style header if no masthead
            if ( !$('.page-masthead').length ) {
                // $('header#site-header').css('background-color', '#00274B');
                $('header#site-header').css('top', '0');
            }

            // Check if footer links are external 
            function link_is_external(link_element) {
                return (link_element.host !== window.location.host);
            }

            $('.site-footer--menus a').each(function() {
                if (link_is_external(this)) {
                    $(this).addClass('external');
                }
            });

            // Check if header links are external 
            function link_is_external(link_element) {
                return (link_element.host !== window.location.host);
            }

            $('.products-mega-menu a').each(function() {
                if (link_is_external(this)) {
                    $(this).addClass('external');
                }
            });

            // Smooth Anchors
            $(document).on('click', 'a[href^="#"]', function (event) {
                var href = $(this).attr('href');
                // Only proceed if there are characters after the #
                if (href.length > 1) {
                    var headerHeight = $('#site-header').height();
                    event.preventDefault();
                    var $target = $(href);
                    if ($target.length) {
                        $('html, body').animate({
                            scrollTop: $target.offset().top - headerHeight - 20
                        }, 800);
                    }
                }
            });

            // Wistia popup player
            $( '[data-wistia-id]' ).on('click', function(e) {
                e.preventDefault();
                var videoId = $(this).attr('data-wistia-id');
                var video = Wistia.api(videoId);
                video.popover.show();
                video.play();
            });

            // Only focus on click
            $('.btn').on('click', function(){
                $('.btn').trigger('blur');
            });

            // Products Nav Mobile 
            $('.menu-item-312 .icon').on( "click", function(e) {
                //$(this).removeClass('target-expanded');
            });

                //setup before functions
            var typingTimer;                //timer identifier
            var doneTypingInterval = 500;  //time in ms (5 seconds)

            // function debounce(callback, delay) {
            //     let timer
            //     return function() {
            //         clearTimeout(timer)
            //         timer = setTimeout(() => {
            //             callback();
            //         }, delay)
            //     }
            // }
            let debounce;

            function clearSearchResults(x = true) {
                if (!x) {
                    $('#form-search input').val('');
                }
                $('.form-search__results li').remove();
            }

            //user is "finished typing," do something
            function getSearchResults (text) {
                var api_url_search = `/wp-json/wp/v2/search?search=${text}&per_page=3&page=1`;
                $.ajax({
                    url:api_url_search,
                    dataType: 'json',
                    success: function(response){ 
                        $('.form-search__results li').remove();
                        console.log(response);
                        renderSearchResults($('.form-search__results'), response);
                    } 
                });
            };

            function renderSearchResults(container, arr = []) {
                if (arr.length > 0) {
                    arr.forEach(title => {
                        container.append(`<li><a href="${title.url}">${title.title}</a></li>`);
                    });	
                } else {
                    container.append('<li>Sorry there are no results for this search</li>');
                }
                $('.form-search__results').show();   
            }

            

            //on keyup, start the countdown
            $('#form-search input').on('input', function(){

                clearTimeout(debounce);
                debounce = setTimeout(() => {
                    if ($('#form-search input').val()) {  
                        var text = $('#form-search input').val();
                        getSearchResults($('#form-search input').val());
                    }
                }, 350);
                
            });
            $('#form-search').on('focusin',function(){
                $(this).addClass('focused');
                console.log('focusin');
            })
            $('#form-search').on('click', function(){
                $(this).addClass('focused');
            });
            // $('#form-search').on('focusout', function(e){
            //     console.log('blurred');
            //     $(this).removeClass('focused');
            //     $('#form-search input').val('');
            //     $('.form-search__results').hide(); 
            // });
            $(document).on('click', function(e) {
                var container = $("#form-search");
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    $('#form-search').removeClass('focused');
                    $('#form-search input').val('');
                    $('.form-search__results').hide(); 
                }
            });

            if ( $('.video-list-lead').length ) {
                $('.video-list-lead').on('click', function(e){
                    $(this).toggleClass('video-list-expanded');
                    $(this).next('.video-list-container').slideToggle('1200');
                })
            }

            var $titles = $('.on-demand__title');
            if ($titles.length > 0) {
                $titles.on('click', function() {
                    $(this).toggleClass('active');
                    $(this).siblings('.on-demand__expand').slideToggle(800);
                });
            }

            if( $('.content-section.template-faqs').length ) {
                // Hide all accordion content by default
                $('.accordion__content').hide();
              
                // On accordion title button click
                $('.accordion__title').click(function() {
              
                  var target = $(this).data('target');
                  var relatedAccordionGroup = $(this).closest('.accordion__group');
                  var relatedAccordionContent = $(target + ' .accordion__content');
                  var prevAccordionGroup = relatedAccordionGroup.prev('.accordion__group');
              
                  // Toggle (show/hide) the related content
                  relatedAccordionContent.slideToggle(function() {
                      // Add or remove the 'open' class based on the visibility of the content after slideToggle completes
                      if (relatedAccordionContent.is(':visible')) {
                          relatedAccordionGroup.addClass('open');
              
                          // Check if the previous accordion group isn't already open
                          if (!prevAccordionGroup.hasClass('open')) {
                              prevAccordionGroup.addClass('hide-border');
                          }
                      } else {
                          relatedAccordionGroup.removeClass('open');
                          // Only remove the hide-border class if the previous accordion group isn't open
                          if (!prevAccordionGroup.hasClass('open')) {
                              prevAccordionGroup.removeClass('hide-border');
                          }
                      }
                  });
              
                  // Change aria-expanded attribute based on whether the accordion is open or not
                  if ($(this).attr('aria-expanded') === 'false') {
                    $(this).attr('aria-expanded', 'true');
                  } else {
                    $(this).attr('aria-expanded', 'false');
                  }
                });
            }

            
		},

        finalize() {
            Scroller.init();
        }
    },
    home: {
        init() {
			ScrollDown.init('#scroll-to-content', '#page-masthead', true);

            if ( $('.hero__heading').length ) {
                $('.hero__heading').css('opacity',0).delay(500).animate({opacity:1}, 1000);
            }

            if ( $('.hero__copy, .hero__subtitle').length ) {
                $('.hero__copy, .hero__subtitle').css('opacity',0).delay(800).animate({opacity:1}, 1000);
            }

            if ( $('.hero__body .btn').length ) {
                $('.hero__body .btn').css('opacity',0).delay(1000).animate({opacity:1}, 1000);
            }
		}
	},

    template_content: {
        init () {

            function pricingText() {
                var maxHeight = -1;

                if ( $('.package--subtitle').length ) {
                    $('.package--subtitle').each(function() {
                        maxHeight = maxHeight > $(this).height() ? maxHeight : $(this).height();
                    });
    
                    $('.package--subtitle-container').each(function() {
                        $(this).attr('style', 'height: ' + maxHeight + "px;");
                    });
                }
            }
            pricingText();

            $(window).on('resize', function(){
                pricingText();
            });

        }
    },

    single: {
        init() {
            SharePost.init();

            if ( $('.icon-email').length ) {
                let postTitle = $('.hero__heading').text();
                var encodedTitle = postTitle.replace(/[\u00A0-\u9999<>\&]/g, function(i) {return '&#'+i.charCodeAt(0)+';';});
                let postBody = "Read the article here: " + window.location.href;
                var encodedBody = postBody.replace(/[\u00A0-\u9999<>\&]/g, function(i) {return '&#'+i.charCodeAt(0)+';';});

                $('.icon-email').attr('href', 'mailto:?subject=Coalesce || ' + encodedTitle + '&body=' + encodedBody);
            }

            if ( $('post--toc') ){
                var tocTitles = [];
                let resultsContainer = $('#coa-toc-table-container');
                function renderTableOfContent(container = resultsContainer, arr) {
                    arr.forEach(title => {
                        container.append(`<li><a href="#${title.id}">${title.text}</a></li>`);
                    });	
                }
                function findAllPostTitles (arr) {
                    $('.post--content').find('h1,h2,h3,h4,h5,h6').each(function(i){
                        let titleObj = {}
                        titleObj.id = 'data-toc-id-' + i;
                        titleObj.text = $(this).text();
                        // set id on title el
                        $(this).attr('id', 'data-toc-id-' + i);
                        arr.push(titleObj);
                    })
                }
                findAllPostTitles(tocTitles);
                renderTableOfContent(resultsContainer, tocTitles);
            }
            
        }
    },

	template_contact: {
		init() {
            Maps.init('.js-map');
            FormFocus.init();
        }
	},

    template_faqs: {
        init() {
            jQuery(document).ready(function($) {

                // Hide all accordion content by default
                $('.accordion__content').hide();
              
                // On accordion title button click
                $('.accordion__title').click(function() {
              
                  var target = $(this).data('target');
                  var relatedAccordionGroup = $(this).closest('.accordion__group');
                  var relatedAccordionContent = $(target + ' .accordion__content');
                  var prevAccordionGroup = relatedAccordionGroup.prev('.accordion__group');
              
                  // Toggle (show/hide) the related content
                  relatedAccordionContent.slideToggle(function() {
                      // Add or remove the 'open' class based on the visibility of the content after slideToggle completes
                      if (relatedAccordionContent.is(':visible')) {
                          relatedAccordionGroup.addClass('open');
              
                          // Check if the previous accordion group isn't already open
                          if (!prevAccordionGroup.hasClass('open')) {
                              prevAccordionGroup.addClass('hide-border');
                          }
                      } else {
                          relatedAccordionGroup.removeClass('open');
                          // Only remove the hide-border class if the previous accordion group isn't open
                          if (!prevAccordionGroup.hasClass('open')) {
                              prevAccordionGroup.removeClass('hide-border');
                          }
                      }
                  });
              
                  // Change aria-expanded attribute based on whether the accordion is open or not
                  if ($(this).attr('aria-expanded') === 'false') {
                    $(this).attr('aria-expanded', 'true');
                  } else {
                    $(this).attr('aria-expanded', 'false');
                  }
                });
            });
        }
    }
};

export default Router;

/*
 * The routing fires all common scripts, followed by the page specific scripts.
 * Add additional events for more control over timing e.g. a finalize event
*/
const UTIL = {

    fire(func, funcname, args) {
        const namespace = Router;
        funcname = (funcname === undefined) ? 'init' : funcname;
        if (func !== '' && namespace[func] && typeof namespace[func][funcname] === 'function') {
            namespace[func][funcname](args);
        }
    },
    loadEvents() {
        UTIL.fire('common');

        $.each(document.body.className.replace(/-/g, '_').split(/\s+/), (i, classnm) => {
            UTIL.fire(classnm);
        });

		UTIL.fire('common', 'finalize');
	}
};

$(document).ready(UTIL.loadEvents);